const row = (
  orderSubmitToProductionDate,
  orderShipDate,
  masterUserEmail,
  ID,
  lineItemsCost,
  lineItemsCostCurrencyCode,
  shippingCostWithoutTax,
  shippingCostCurrencyCode,
  totalTax,
  totalAmountPaidUsd,
  totalAmountPaidCad,
  productName,
  color,
  size,
  quantity
) => {
  return {
    orderSubmitToProductionDate,
    orderShipDate,
    masterUserEmail,
    ID,
    lineItemsCost,
    shippingCostWithoutTax,
    totalTax,
    totalAmountPaidUsd,
    totalAmountPaidCad,
    productName,
    color,
    size,
    quantity,
    lineItemsCostCurrencyCode,
    shippingCostCurrencyCode,
  };
};

export { row };
